import React from 'react';
import { Trophy, CheckCircle2 } from 'lucide-react';
export function Product() {
  return <section className="py-20 bg-[#FAF6EE]" data-id="element-247">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-248">
        <div className="text-center mb-16" data-id="element-249">
          <div className="inline-flex items-center justify-center px-4 py-2 bg-brand-gold/15 text-brand-gold rounded-full font-bold text-sm uppercase tracking-wider mb-6" data-id="element-250">
            <Trophy className="w-4 h-4 mr-2" data-id="element-251" />
            El Sistema N°1 para Profesores de Italiano Argentinos
          </div>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-[#1F1A17] mb-4" data-id="element-252">
            ITALIANO 360 — Colección Completa
          </h2>
          <p className="text-2xl text-gray-600 font-serif italic" data-id="element-253">
            12 Tomos + 6 Bonus + 2 Elite
          </p>
        </div>

        <div className="max-w-2xl mx-auto text-center space-y-8" data-id="element-254">
          <h3 className="text-3xl font-bold text-[#1F1A17]" data-id="element-255">
            Todo resuelto, todos los niveles.
          </h3>

          <ul className="space-y-4 inline-block text-left" data-id="element-256">
            {['+240 páginas', '+120 ejercicios graficados', 'Todos los niveles A1 → C2', '100% adaptado a Argentina'].map((item, i) => <li key={i} className="flex items-center text-xl text-gray-700" data-id="element-257">
                <CheckCircle2 className="w-6 h-6 text-brand-green mr-4 flex-shrink-0" data-id="element-258" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}